
import React from 'react';
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface GoalMetricsCardsProps {
  totalGoals: number;
  activeGoals: number;
  averageProgress: number;
  completedGoals: number;
}

export const GoalMetricsCards: React.FC<GoalMetricsCardsProps> = ({
  totalGoals,
  activeGoals,
  averageProgress,
  completedGoals
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card className="bg-gradient-to-br from-blue-500/20 to-blue-600/30 border-blue-500/30 hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300">
        <CardHeader className="pb-2 pt-3">
          <CardTitle className="text-white flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <div className="text-xl font-bold text-blue-400">{totalGoals}</div>
              <span className="text-[13px]">Total Goals</span>
            </div>
            <Badge className="bg-blue-500/20 text-blue-300 border-blue-500/50 text-xs">
              {activeGoals} active
            </Badge>
          </CardTitle>
        </CardHeader>
      </Card>

      <Card className="bg-gradient-to-br from-green-500/20 to-green-600/30 border-green-500/30 hover:shadow-lg hover:shadow-green-500/25 transition-all duration-300">
        <CardHeader className="pb-2 pt-3">
          <CardTitle className="text-white flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <div className="text-xl font-bold text-green-400">{activeGoals}</div>
              <span className="text-[13px]">Active Goals</span>
            </div>
            <Badge className="bg-green-500/20 text-green-300 border-green-500/50 text-xs">
              In progress
            </Badge>
          </CardTitle>
        </CardHeader>
      </Card>

      <Card className="bg-gradient-to-br from-purple-500/20 to-purple-600/30 border-purple-500/30 hover:shadow-lg hover:shadow-purple-500/25 transition-all duration-300">
        <CardHeader className="pb-2 pt-3">
          <CardTitle className="text-white flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <div className="text-xl font-bold text-purple-400">{averageProgress}%</div>
              <span className="text-[13px]">On Track</span>
            </div>
            <Badge className="bg-purple-500/20 text-purple-300 border-purple-500/50 text-xs">
              Avg progress
            </Badge>
          </CardTitle>
        </CardHeader>
      </Card>

      <Card className="bg-gradient-to-br from-yellow-500/20 to-yellow-600/30 border-yellow-500/30 hover:shadow-lg hover:shadow-yellow-500/25 transition-all duration-300">
        <CardHeader className="pb-2 pt-3">
          <CardTitle className="text-white flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <div className="text-xl font-bold text-yellow-400">{completedGoals}</div>
              <span className="text-[13px]">Completed</span>
            </div>
            <Badge className="bg-yellow-500/20 text-yellow-300 border-yellow-500/50 text-xs">
              Achieved
            </Badge>
          </CardTitle>
        </CardHeader>
      </Card>
    </div>
  );
};
